import type { DataTableColumn } from '@/components/custom/erp/data-table-v2';

export const exportMainColumns = (): DataTableColumn[] => [
  { field: 'checkbox', headerName: '', width: 50 },
  { field: 'ngay_ctu', headerName: 'Ngày chứng từ', width: 150 },
  { field: 'so_ctu', headerName: 'Số chứng từ', width: 150 },
  { field: 'ma_kh', headerName: 'Mã khách hàng', width: 150 },
  { field: 'ten_kh', headerName: 'Tên khách hàng', width: 150 },
  { field: 'dien_giai', headerName: 'Diễn giải', width: 150 },
  { field: 'tai_khoan', headerName: 'Tài khoản', width: 150 },
  { field: 'tien_tat_toan_nt', headerName: 'Tiền tất toán NT', width: 150 },
  { field: 'tong_tien', headerName: 'Tổng tiền', width: 150 },
  { field: 'da_thanh_toan', headerName: 'Đã thanh toán', width: 150 },
  { field: 'con_lai', headerName: 'Còn lại', width: 150 },
  { field: 'tien_tat_toan', headerName: 'Tiền tất toán', width: 150 },
  { field: 'ma_chung_tu', headerName: 'Mã chứng từ', width: 150 },
  { field: 'don_vi', headerName: 'Đơn vị', width: 150 }
];

export const KhuVucColDef: DataTableColumn[] = [
  { field: 'ma_khu_vuc', headerName: 'Mã khu vực', flex: 1 },
  { field: 'ten_khu_vuc', headerName: 'Tên khu vực', flex: 2 }
];
